import { Link } from "react-router-dom";
// import arch10 from '../../assets/images/arch10.jpg';
// import arch11 from '../../assets/images/arch11.jpg';
// import arch12 from '../../assets/images/arch12.jpg';
// import arch4 from '../../assets/images/arch4.jpg';
// import arch5 from '../../assets/images/arch5.jpg';
// import arch6 from '../../assets/images/arch6.jpg';
// import arch7 from '../../assets/images/arch7.jpg';
// import arch8 from '../../assets/images/arch8.jpg';
// import arch9 from '../../assets/images/arch9.jpg';
import arch1 from '../../assets/images/inte1.jpg';
import arch2 from '../../assets/images/inte2.jpg';
import arch3 from '../../assets/images/inte3.jpg';
import Layout from "../Layout/Layout";
import Contact from "./contact/Contact";
import { META_DESCRIPTION, META_TITLE } from "../../constants/seo.constants";

const Interior = () => {
  return (
    <Layout title={META_TITLE.INTERIOR_DESIGN_SERVICE} description={META_DESCRIPTION.INTERIOR_DESIGN_SERVICE}>
      <div className="ttm-page-title-row">
        <div className="ttm-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="page-title-heading">
                  <h2 className="title">Interior Work</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <div className="container">
                    <div className="breadcrumb-wrapper-inner">
                      <span>
                        <Link title="Go to Home." to="/" className="home"><i className="themifyicon ti-home"></i>&nbsp;&nbsp;Home</Link>
                      </span>
                      <span className="ttm-bread-sep">&nbsp; / &nbsp;</span>
                      <span>Interior Work</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="site-main">

        <div className="ttm-row sidebar ttm-sidebar-left ttm-bgcolor-white clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 widget-area sidebar-left">
                <aside className="widget widget-nav-menu">
                  <h3 className="widget-title">More Services</h3>
                  <ul className="widget-menu">
                    <li><Link to="/architecture">Architecture</Link></li>
                    <li className="active"><Link to="/interior">Interior Work</Link></li>
                    <li><Link to="/layouts">2D/3D Layouts</Link></li>
                    <li><Link to="/project-development">Project Development</Link></li>
                  </ul>
                </aside>
                <Contact />
                {/* <aside className="widget widget-archive">
                  <h3 className="widget-title">Gallery</h3>
                  <div id="gallery-2" className="gallery-wrapper">
                    <figure className="gallery-item">
                      <div className="gallery-icon landscape">
                        <img width="150" height="150" className="img-fluid" src={arch4} alt="gellary_img" />
                      </div>
                    </figure>
                    <figure className="gallery-item">
                      <div className="gallery-icon landscape">
                        <img width="150" height="150" className="img-fluid" src={arch5} alt="gellary_img" />
                      </div>
                    </figure>
                    <figure className="gallery-item">
                      <div className="gallery-icon landscape">
                        <img width="150" height="150" className="img-fluid" src={arch6} alt="gellary_img" />
                      </div>
                    </figure>
                    <figure className="gallery-item">
                      <div className="gallery-icon landscape">
                        <img width="150" height="150" className="img-fluid" src={arch7} alt="gellary_img" />
                      </div>
                    </figure>
                    <figure className="gallery-item">
                      <div className="gallery-icon landscape">
                        <img width="150" height="150" className="img-fluid" src={arch8} alt="gellary_img" />
                      </div>
                    </figure>
                    <figure className="gallery-item">
                      <div className="gallery-icon landscape">
                        <img width="150" height="150" className="img-fluid" src={arch9} alt="gellary_img" />
                      </div>
                    </figure>
                    <figure className="gallery-item">
                      <div className="gallery-icon landscape">
                        <img width="150" height="150" className="img-fluid" src={arch10} alt="gellary_img" />
                      </div>
                    </figure>
                    <figure className="gallery-item">
                      <div className="gallery-icon landscape">
                        <img width="150" height="150" className="img-fluid" src={arch11} alt="gellary_img" />
                      </div>
                    </figure>
                    <figure className="gallery-item">
                      <div className="gallery-icon landscape">
                        <img width="150" height="150" className="img-fluid" src={arch12} alt="gellary_img" />
                      </div>
                    </figure>
                  </div>
                </aside> */}
              </div>
              <div className="col-lg-8 content-area">
                <article className="ttm-service-single-content-area">
                  <div className="ttm-service-featured-wrapper ttm-featured-wrapper">
                    <div className="ttm_single_image-wrapper mb-45 res-991-mb-30">
                      <img width="1200" height="800" className="img-fluid" src={arch1} alt="project-6" />
                    </div>
                  </div>
                  <div className="ttm-service-classic-content">
                    <h2>Elevate Your Space: Transformative Interior Design by Kritajna Homes</h2>
                    <p>At Kritajna Homes, we know that every individual and every space has its own story. That’s why we offer a wide range of services tailored to bring your vision to life. Our mission isn’t just to design spaces—it’s to create experiences that resonate with your personality and needs.</p>
                    <p>Our expertise lies in crafting interiors that blend beauty, functionality, and personalization. Be it a home, office, or commercial property, Kritajna Homes’s design professionals excel in turning ordinary environments into extraordinary works of art.</p>
                    <div className="ttm-horizontal_sep width-100 mt-30 mb-30 res-991-mt-15"></div>
                    <div className="row">
                      <div className="col-md-7">
                        <h2>Expert Designers Tailored to Your Needs</h2>
                        <p>Behind every stunning design is a team of dedicated professionals. At Kritajna Homes, our success is powered by a group of highly trained, skilled, and passionate individuals who turn concepts into reality. Every member of our team is equipped to deliver precision and creativity, ensuring each project is a masterpiece.</p>
                        {/* <a className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-darkgrey mt-20" href="team-details.html" tabIndex={0}>Read More</a> */}
                      </div>
                      <div className="col-md-5">
                        <div className="ttm_single_image-wrapper res-767-pt-30">
                          <img width="450" height="500" className="img-fluid" src={arch2} alt="team-img02" />
                        </div>
                      </div>
                    </div>
                    <div className="ttm-horizontal_sep width-100 mt-30 mb-30"></div>
                    <div className="row">
                      <div className="col-md-5">
                        <div className="ttm_single_image-wrapper res-767-pb-30">
                          <img width="450" height="500" className="img-fluid" src={arch3} alt="team-img01" />
                        </div>
                      </div>
                      <div className="col-md-7">
                        <h2>Sustainability Meets Superior Quality</h2>
                        <p>Kritajna Homes champions eco-friendly practices in every design we create. By incorporating sustainable materials, energy-efficient solutions, and green initiatives, we help you reduce your ecological footprint. Our team also ensures that every project stays on schedule, adheres to budget constraints, and meets the highest standards of quality.</p>
                        {/* <a className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-darkgrey mt-20" href="team-details.html" tabIndex={0}>Read More</a> */}
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Interior